import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams } from "react-router-dom"
import Alert from 'react-bootstrap/Alert'
import { FaBars } from 'react-icons/fa'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { FaEdit, FaPlus } from 'react-icons/fa'
import { apiURL, sitePath, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import ModelViewer3d from "components/ModelViewer3d"
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'
import { createRecord } from 'utils/RecordManager'

const BuildingDetails = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [building, setBuilding] = useState({})
    const [records, setRecords] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const navigate = useNavigate()
    const { buildingId } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getBuilding(buildingId)
            getRecords()
        }
        start()
    }, [])

    const getBuilding = async (id) => {
        const response = await axios.get(`${apiURL}/get-building/${id}`)

        if (!response.data.success) {
            setErrorMessage(response.data.error || response.data)
            return
        }

        setBuilding(response.data.item)
    }

    const getRecords = async () => {
        const response = await axios.get(`${apiURL}/get-records`)
        setRecords(response.data.rows.filter(x => x.buildingId === building.id) || [])
    }

    const createNewRecord = () => {
        createRecord()
        navigate(`/buildings/${building.id}/records/new`)
    }

    const edit = () => {
        navigate(`/buildings/${building.id}/edit`)
    }

    const viewRecord = (id) => {
        const record = records.find(x => x.id === id)
        navigate(`/buildings/${record.buildingId}/records/${record.id}`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="buildings" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Buildings', '/buildings'], [building.name]]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>{building.name}</h1>
                    </div>
                    <Button variant="primary" className="float-end" onClick={edit}>
                        <FaEdit /> Edit Building
                    </Button>
                    <Button variant="primary" className="float-end mx-3" onClick={createNewRecord}>
                        <FaPlus /> Add Record
                    </Button>
                </header>
                {errorMessage && 
                    <Alert key='submitError' variant='danger'>
                        {errorMessage}
                    </Alert>
                }
                {building.modelType === '3d' &&
                    <ModelViewer3d
                        modelFileName={building.modelFile}
                        record={building}
                        allowNewMarkers={false}
                    />
                }
                {building.modelType === '2d' &&
                    <img src={`${filesURL}/${building.modelFile}`} width="100%" />
                }
                <h5 className="mt-5">Records</h5>
                {records.length
                    ? <Table striped bordered hover size="sm" className="hoverTableRows">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Building</th>
                                <th>Created by</th>
                                <th>Created at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records
                                .map(record => (
                                    <tr key={record.id} onClick={() => viewRecord(record.id)} className="recordRow">
                                        <td>
                                            {record.id}
                                        </td>
                                        <td>
                                            {record.buildingName}
                                        </td>
                                        <td>
                                            {record.createdBy}
                                        </td>
                                        <td>
                                            {record.createdAt}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                      </Table>
                    : <>
                        No records found.
                      </>
                }


                        
                        
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default BuildingDetails